import { css, Theme } from '@emotion/react'
import styled from '@emotion/styled'

export const TopMenuWrapper = styled.div(
  (props: { theme: Theme }) => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1em;
    background: white;
    height: 60px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid white;
    transition: background 0.1s linear, border-bottom 0.1s linear;
    z-index: 10;

    &.open {
      background: ${props.theme.defaultMenuBackground};
      box-shadow: none;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }
  `
)

export const Wrapper = styled.div`
  display: flex;
  gap: 1em;
  align-items: center;

  & > svg {
    &:nth-of-type(2) {
      margin-left: 0.5em;
    }
  }

  & > button > span {
    display: flex;
  }
`

export const Img = styled.img`
  max-height: 35px;
  max-width: 75px;
  cursor: pointer;
`
